import Mutations from '../../odata/mutations';

export default { ...new Mutations('jobListingNotification'), ...new Mutations('jobListingNotifications') };
